import { applyAction } from "./appliers";
import type { LoveWinsAllAction, LoveWinsAllState } from "./types";
import { validateAction } from "./validators";

export interface ReduceResult {
  readonly state: LoveWinsAllState;
  readonly accepted: boolean;
  readonly error?: string;
}

// NOTE: does NOT validate — call validateAndReduceGameState at trust boundaries.
export function reduceGameState(
  state: LoveWinsAllState,
  action: LoveWinsAllAction,
): LoveWinsAllState {
  return applyAction(state, action);
}

export function validateAndReduceGameState(
  state: LoveWinsAllState,
  action: LoveWinsAllAction,
): ReduceResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return { state, accepted: false, error: validation.error };
  }
  return { state: reduceGameState(state, action), accepted: true };
}
